import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import GradientCanvas from '../landing/new/GradientCanvas';
import { CardSpotlight } from '../landing/new/CardSpotlight';

// Shared shell for /login and /signup — matches the landing page:
// #1C1C1E base, animated mesh GradientCanvas backdrop + scrim, VH Intelligence
// wordmark top bar with an optional cross-link, centered content. UI only.
const EASE = [0.22, 1, 0.36, 1];

export const AuthLayout = ({ children, topRightText, topRightTo, topRightCta }) => {
  const reduce = useReducedMotion();
  return (
    <div className="min-h-screen bg-white text-[#1C1C1E] relative overflow-hidden flex flex-col font-sans">
      <CardSpotlight />
      {/* Animated mesh gradient (Command Center palette) */}
      <div className="absolute inset-0 z-0">
        <GradientCanvas />
      </div>
      {/* Scrim — keeps the form legible while the gradient glows as ambient brand light */}
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-white/40 via-white/75 to-white" />
      <div className="absolute inset-0 z-[1] bg-white/55" />

      {/* Top bar */}
      <header className="relative z-10 w-full">
        <div className="max-w-[1120px] mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center group">
            <img
              src="/vh-intelligence-ink.png"
              alt="VH Intelligence"
              className="h-7 sm:h-8 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>
          {topRightTo && (
            <div className="flex items-center gap-3 text-sm">
              {topRightText && <span className="hidden sm:inline text-slate-600">{topRightText}</span>}
              <Link
                to={topRightTo}
                className="px-4 py-2 rounded-full bg-white hover:bg-black/[0.03] border border-black/10 text-[#1C1C1E] font-medium shadow-sm transition-colors"
              >
                {topRightCta}
              </Link>
            </div>
          )}
        </div>
      </header>

      {/* Content */}
      <main className="relative z-10 flex-1 flex items-center justify-center px-4 pb-14 pt-2">
        <motion.div
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 20 }}
          animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="w-full flex justify-center"
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
};

export default AuthLayout;
